import { render, staticRenderFns } from "./BookmarkCollapse.vue?vue&type=template&id=3e4a8102&"
import script from "./BookmarkCollapse.vue?vue&type=script&lang=js&"
export * from "./BookmarkCollapse.vue?vue&type=script&lang=js&"
import style0 from "./BookmarkCollapse.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports